angular.module('BGEHeroes.services.LoaderSvcLepes2', [])

.service('loaderSvcLepes2', [ 'Gateway',  function (Gateway) {
   var manifest = [ 
       {src: "lepes2/hatter.png", id: "hatter1"},
       {src: "kozos/jobbra.png", id: "jobbra"},
       {src: "kozos/balra.png", id: "balra"},
       {src: "kozos/logo.png", id: "logo"},
       {src: "kozos/bar.png", id: "bar"},
       {src: "kozos/tovabb.png", id: "tovabb"},
       {src: "kozos/ujra.png", id: "ujra"},
	   {src: "kozos/ablak_nagy.png", id: "ablak_nagy"},
	   {src: "kozos/tipp.png", id: "tipp"},
	   
	   {src: "kozos/kihagy.png", id: "kihagy"},
			  
	   ];
   
   loader = new createjs.LoadQueue(false);
   
   this.getResult = function (asset) {
       return loader.getResult(asset);
   };
   this.getLoader = function () {
       return loader;
   };
   this.loadAssets = function () {  
		loader.loadManifest(manifest, true, Gateway.cordovaprefix + "/images/");
   };
}]);